import React, { useEffect } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { ReactComponent as ArrowForwardIosIcon } from "../../assets/icons/nextArrow.svg";
import { ReactComponent as ArrowBackIosIcon } from "../../assets/icons/prevArrow.svg";
import ImageBanner from "../../assets/images/banners/bannerCasino.jpg";
import styled from "styled-components";
import { PRIMARY , SECONDARY } from "../../const/colors";
import { API_URL } from "../../const/api";
import LoaderFull from "../LoaderFull";
import axios from "axios";
import { useState } from "react";

const StyledSlider = styled(Slider)`
  max-height: ${(props) => props.size};
  position: "relative";
  @media screen and (min-width: 1800px) {
    min-height: ${(props) =>
      props.main === "home 1"
        ? "550px"
        : props.main === "home 2"
        ? "290px"
        : `calc(${props.size})`};
  }
  @media screen and (min-width: 1500px) and (max-width: 1799px) {
    min-height: ${(props) =>
      props.main === "home 1"
        ? "450px"
        : props.main === "home 2"
        ? "220px"
        : `calc(${props.size})`};
  }
  @media screen and (min-width: 1300px) and (max-width: 1499px) {
    min-height: ${(props) =>
      props.main === "home 1"
        ? "420px"
        : props.main === "home 2"
        ? "200px"
        : `calc(${props.size})`};
  }
  @media screen and (min-width: 1080px) and (max-width: 1299px) {
    min-height: ${(props) =>
      props.main === "home 1"
        ? "400px"
        : props.main === "home 2"
        ? "180px"
        : `calc(${props.size})`};
  }
  /* @media screen and (max-width: 1199px) {
		min-height: ${(props) => `calc(${props.size})`};
	} */
`;

const ForwardIcon = styled(ArrowForwardIosIcon)`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 2rem !important;
  z-index: 1;
  opacity: ${(props) => props.active};
  transition: all 0.3s ease-in-out;
  width: 55px !important;
  height: 55px !important;
  path {
    transition: all 0.3s ease-in-out;
  }
  &:hover path {
    stroke: ${PRIMARY};
  }
  @media screen and (max-width: 1080px) {
    opacity: 0;
  }
  background: #14172c;
  border: 2px solid #fecd05;
  padding: 0.5rem;
  border-radius: 100%;
`;
const BackIcon = styled(ArrowBackIosIcon)`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: 2rem !important;
  z-index: 1;
  opacity: ${(props) => props.active};
  transition: color 0.3s ease-in-out;
  width: 55px !important;
  height: 55px !important;
  path {
    transition: all 0.3s ease-in-out;
  }
  &:hover path {
    stroke: ${PRIMARY};
  }

  @media screen and (max-width: 1080px) {
    opacity: 0;
  }
  background: #14172c;
  border: 2px solid #fecd05;
  padding: 0.5rem;
  border-radius: 100%;
`;

const ImgContainer = styled.div`
  min-width: 100%;
  height: ${(props) => props.size};
  padding: ${(props) => props.padding};
  position: relative;
  overflow: hidden;
  text-align: center;
  display:flex;
  @media screen and (min-width: 1800px) {
    min-height: ${(props) =>
      props.main === "home 1"
        ? "550px"
        : props.main === "home 2"
        ? "290px"
        : `calc(${props.size})`};
  }
  @media screen and (min-width: 1500px) and (max-width: 1799px) {
    min-height: ${(props) =>
      props.main === "home 1"
        ? "450px"
        : props.main === "home 2"
        ? "220px"
        : `calc(${props.size})`};
  }
  @media screen and (min-width: 1300px) and (max-width: 1499px) {
    min-height: ${(props) =>
      props.main === "home 1"
        ? "420px"
        : props.main === "home 2"
        ? "200px"
        : `calc(${props.size})`};
  }
  @media screen and (min-width: 1080px) and (max-width: 1299px) {
    min-height: ${(props) =>
      props.main === "home 1"
        ? "400px"
        : props.main === "home 2"
        ? "180px"
        : `calc(${props.size})`};
  }
  /* @media screen and (max-width: 1199px) {
		min-height: ${(props) => `calc(${props.size})`};
	} */
`;

const CustomDot = styled.div`
  width: 25px;
  height: 5px;
  background-color: #fff;
  position: absolute;
  bottom: 1.6rem;
  transition: background-color 0.3s ease-in-out;
  &:hover {
    background-color: ${PRIMARY};
  }

  @media screen and (max-width: 1080px) {
    bottom: 1.5rem;
  }
`;

const Img = styled.img`
  // position: absolute;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  //object-fit: cover;
  border: ${(props) => props.border};
  border-radius: ${(props) => props.radius};
  min-height: 100%;
  min-width: 100%;
  max-width: 100%;
  z-index: -1;
  width:100%;
  height:100%;
`;

const Span = styled.span`
  position: relative;
  z-index: 2;
  &.slick-prev:before,
  &.slick-next:before {
    font-size: 0;
    content: "";
    height: 0;
    width: 0;
  }
  &.slick-prev{
    left:0%;
  }
  &.slick-next{
    right:0%;
  }
  opacity:0.5;
  transition: all 0.3s ease-in-out;
  &.slick-next:hover{
    transition: all 0.3s ease-in-out;
    opacity:1;
  }
  &.slick-prev:hover{
    transition: all 0.3s ease-in-out;
    opacity:1;
  }
`;

const PrevArrow = ({ currentSlide, slideCount, children, ...props }) => (
  <Span {...props}>{children}</Span>
);
const NextArrow = ({ currentSlide, slideCount, children, ...props }) => (
  <Span {...props}>{children}</Span>
);

const Banner = (props) => {
  const settings = {
    centerMode: props.centerMode,
    centerPadding: props.centerPadding,
    dots: props.indicators,
    fade: props.fade,
    infinite: true,
    speed: 500,
    slidesToShow: props.show,
    slidesToScroll: 1,
    autoplay: true,
    pauseOnHover: true,
    autoplaySpeed: props.time,
    cssEase: "ease-in-out",

    prevArrow: (
      <PrevArrow>
        <BackIcon active={props.indicators ? 0 : 1} />
      </PrevArrow>
    ),
    nextArrow: (
      <NextArrow>
        <ForwardIcon active={props.indicators ? 0 : 1} />
      </NextArrow>
    ),
    customPaging: (i) => {
      return <CustomDot />;
    },
  };

  const [imagenes, setImagenes] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    const loadData = async () => {
      let json = null;

      if (props.rutaAlterna) {
        const resAlt = await axios.post(API_URL + "imagenes", {
          ruta: props.rutaAlterna,
        });
        json = JSON.parse(resAlt.data);
      }
      const res = await axios.post(API_URL + "imagenes", {
        ruta: props.lang + "-" + props.folder,
      });

      if (res.data) {
        setLoading(false);
        if (json && json.length > 0 && props.lang.toLowerCase()==='es') setImagenes(json);
        else setImagenes(JSON.parse(res.data));
      }
    };
    loadData();
  }, [props.lang, props.rutaAlterna]);

  return (
    <div>
      {loading && <LoaderFull />}
      <StyledSlider {...settings} {...props}>
        {imagenes &&
          imagenes.map((item, i) => (
            <ImgContainer size={props.size} main={props.main} padding={props.padding} key={i}>
              <Img
                size={props.size}
                border={props.border}
                radius={props.radius}
                alt=""
                src={`https://admin.betsfactory.co/admin/contenido/${item}`}
              />
            </ImgContainer>
          ))}
      </StyledSlider>
    </div>
  );
};

export default Banner;
